import {
  gramToLalConversion,
  LalToGramConversion,
} from '../formula/CodeWindow';
import barcodePrintTags from './barcodePrintTags';
import Cookies from 'js-cookie';

const barcodeTags = barcodePrintTags.map((tag) => {
  return tag.value;
});

function returnDiamondStoneInfo(extraDetails, index, item) {
  return extraDetails?.[index]?.diamondStones?.filter(
    (stone) => stone.itemTypeName === item.split('-')[1],
  );
}

function calculateDiamondStoneInfo(diamondStones) {
  let totalAmount = 0;
  diamondStones?.map((stone) => {
    if (stone.rateOn === 'pcs') {
      totalAmount += stone.salesRate * parseInt(stone.pcs);
    } else if (stone.rateOn === 'wt') {
      totalAmount += stone.salesRate * parseInt(stone.weight);
    } else if (stone.rateOn === 'bulk') {
      totalAmount += stone.salesRate;
    }
  });
  return totalAmount;
}

const isEmpty = (value) => {
  const data =
    String(value)?.includes('lal') || String(value)?.includes('gm')
      ? String(value)?.split(' ')[0]
      : value;
  if (
    data == '0' ||
    data == 0 ||
    data === null ||
    data === undefined ||
    data === ''
  ) {
    return false;
  } else {
    return true;
  }
};

export default function returnPRN(
  prn,
  barcode,
  itemName,
  index,
  extraDetails,
  summaryData,
  form,
) {
  const primaryCalculationType = Cookies.get('primaryCalculationType');
  const templateReplacements = {
    // Default replacement strategy
    default: (tagName) => {
      // Check if the tag is an InfoLabel
      const infoLabelMatch = tagName.match(/^InfoLabel:(.+)$/);
      const infoValueMatch = tagName.match(/^InfoValue:(.+)$/);

      if (infoLabelMatch) {
        const key = infoLabelMatch[1];

        // First, check if the key exists in barcodeTags
        if (barcodeTags[key]) return barcodeTags[key];

        if (barcodePrintTags?.find((tag) => tag.value === key)) {
          return barcodePrintTags.find((tag) => tag.value === key).label;
        }

        // If no value found, return the original tag
        return `<${tagName}>`;
      }

      if (infoValueMatch) {
        const key = infoValueMatch[1].split(',')[0];

        const length = infoValueMatch[1].split(',')[1]
          ? infoValueMatch[1].split(',')[1]
          : primaryCalculationType === 'lal'
            ? 1
            : 3;
        // First, check if the key exists in barcodeTags
        if (barcodeTags[key]) {
          return isEmpty(barcodeTags[key]) ? '' : barcodeTags[key];
        }
        if (isEmpty(extraDetails?.[index]?.[key])) {
          if (
            barcodePrintTags?.find((tag) => tag?.value === key).type === 'info'
          ) {
            // return Number.parseFloat(extraDetails?.[index][key]).toFixed(
            //   length,
            // );

            //newly added for stone weight and gross weight

            // if (
            //   key === 'grossWeight' &&
            //   Number(extraDetails?.[index]?.[key]) === 0
            // ) {
            //   return '';
            // }

            // if (
            //   key === 'stoneWeight' &&
            //   Number(extraDetails?.[index]?.[key]) === 0
            // ) {
            //   return '';
            // }

            // if(key.includes)
            if (key.toLowerCase().includes('amount')) {
              return Number.parseFloat(extraDetails[index][key]).toFixed(
                length || 3,
              );
            } else {
              return Number.parseFloat(extraDetails[index][key]).toFixed(
                length,
              );
            }
          } else if (
            barcodePrintTags.find((tag) => tag.value === key).type === 'text'
          ) {
            return extraDetails[index][key].slice(0, length);
          } else {
            return extraDetails[index][key];
          }
        } else if (
          extraDetails?.[index]?.diamondData &&
          extraDetails?.[index]?.diamondData?.length > 0 &&
          key?.includes('Diamond')
        ) {
          const keys = key.split('-');
          return (
            extraDetails?.[index]?.diamondData?.[
              Number(parseInt(keys[2])) - 1
            ]?.[keys[1]] || 0
          );
        } else if (
          extraDetails?.[index]?.stoneData &&
          extraDetails?.[index]?.stoneData?.length > 0 &&
          key.includes('Stone')
        ) {
          const keys = key.split('-');
          return (
            extraDetails?.[index]?.stoneData?.[Number(parseInt(keys[2])) - 1]?.[
              keys[1]
            ] || 0
          );
        } else if (key === 'netWeightSc') {
          if (extraDetails[index]['netWeight'].includes('lal')) {
            return LalToGramConversion(
              Number.parseFloat(extraDetails[index]['netWeight']),
            ).toFixed(length);
          } else {
            return gramToLalConversion(
              Number.parseFloat(extraDetails[index]['netWeight']),
            ).toFixed(length);
          }
        } else if (key === 'wtInTola') {
          const netWeightStr = extraDetails[index]['netWeight'] || '';
          let value = 0; // default

          const parts = netWeightStr.trim().split(' ');
          const num = parseFloat(parts[0]);

          if (!isNaN(num)) {
            if (netWeightStr.includes('lal')) {
              value = num / 100;
            } else if (netWeightStr.includes('gm')) {
              value = gramToLalConversion(num) / 100;
            }
          }

          return value.toFixed(length);
        }

        // If no value found, return the original tag
        return '';
      }
      // Existing replacement logic for other tags
      switch (tagName) {
        case 'Barcode':
          return extraDetails?.[index]?.itemCode;
        case 'itemCode':
          return extraDetails?.[index]?.itemCode;
        case 'groupName':
          return extraDetails?.[index]?.groupName;
        case 'categoryName':
          return extraDetails?.[index]?.categoryName;
        case 'itemGroup':
          // return extraDetails?.[index]?.itemCode;
          return extraDetails?.[index]?.groupName;
        case 'description':
          return extraDetails?.[index]?.description;
        case 'karigarName':
          return extraDetails?.[index]?.karigarName;
        case 'itemName':
          return itemName;
        case 'Purity':
          return extraDetails?.[index]?.purityInCarat;
        case 'totalSalesStoneAmount':
          return summaryData
            ? summaryData?.totalSalesStoneAmount
            : extraDetails?.[index]?.totalSalesStoneAmount;
        case 'totalSalesDiamondAmount':
          return summaryData
            ? summaryData?.totalSalesDiamondAmount
            : extraDetails?.[index]?.totalSalesDiamondAmount;
        // case 'PurityInPercent':
        //   return extraDetails?.[index]?.purity;
        case 'printQty':
          return Number(form.getFieldValue('printQuantity')) || '';
        case 'generalRemarks':
          return form.getFieldValue('generalRemarks') || '';
        case 'size':
          return extraDetails?.[index]?.size || '';
        // case 'wtInTola':
        //   return extraDetails?.[index]?.netWeight / 100 || '';
        default:
          // Check barcodeTags for any custom tags
          if (extraDetails?.[index]?.[tagName])
            return extraDetails?.[index]?.[tagName];
          return `<${tagName}>`;
      }
    },
  };

  const templateTagRegex = /<([^>]+)>/g; // Capture whole line + tag

  return prn
    .split('\n')
    .map((line) => {
      // Find all tags in the line
      const tags = [...line.matchAll(templateTagRegex)].map((m) => m[1]);

      // If line has no tags, keep it as-is
      if (tags.length === 0) return line;

      // Check if ALL tags are empty
      const allTagsEmpty = tags.every((tag) => {
        const value = templateReplacements.default(tag);
        return value === '' || value === null || value === undefined;
      });

      // If all tags are empty, remove the entire line
      if (allTagsEmpty) return '';

      // Otherwise, replace all tags (some might be empty, some might have values)
      templateTagRegex.lastIndex = 0; // Reset regex
      let replacedLine = line.replace(templateTagRegex, (match, tagName) => {
        const value = templateReplacements.default(tagName);
        return value == null ? '' : value; // Replace empty tags with empty string
      });

      return replacedLine;
    })
    .filter(Boolean) // Remove empty lines from final output
    .join('\n');
  // return prn
  //   .split('\n')
  //   .map((line) => {
  //     // Find all tags in the line
  //     const tags = [...line.matchAll(templateTagRegex)].map((m) => m[1]);

  //     console.log('tags', tags);

  //     // If any tag is empty/0/null/undefined, remove the whole line
  //     const hasEmptyTag = tags.some((tag) => {
  //       const value = templateReplacements.default(tag);
  //       console.log('value', value);
  //       return (
  //         // value === '' || value === null || value === undefined || value === 0
  //         value === '' || value === null || value === undefined
  //       );
  //     });

  //     if (hasEmptyTag) return '';

  //     // Replace all tags
  //     let replacedLine = line.replace(templateTagRegex, (match, tagName) => {
  //       return templateReplacements.default(tagName);
  //     });

  //     return replacedLine;
  //   })
  //   .join('\n');

  // return prn
  //   .split('\n')
  //   .map((line) => {
  //     let replacedLine = line;

  //     replacedLine = replacedLine.replace(
  //       templateTagRegex,
  //       (match, tagName, offset, str) => {
  //         const value = templateReplacements.default(tagName);

  //         if (
  //           value === '' ||
  //           value === null ||
  //           value === undefined ||
  //           value === 0
  //         ) {
  //           return '';
  //         }

  //         return value;
  //       },
  //     );

  //     replacedLine = replacedLine
  //       .replace(/\b[A-Za-z]+[=:]\s*(?=\s|$)/g, '')
  //       .replace(/\s{2,}/g, ' ')
  //       .trimEnd();

  //     return replacedLine;
  //   })
  //   .join('\n');
}

export const returnPreviewPRN = (
  prn,
  barcode,
  itemName,
  index,
  extraDetails,
  summaryData,
  form,
) => {
  const prnKeyValueMap = {};
  const primaryCalculationType = Cookies.get('primaryCalculationType');

  const templateReplacements = {
    // Default replacement strategy
    default: (tagName) => {
      // Check if the tag is an InfoLabel
      const infoLabelMatch = tagName.match(/^InfoLabel:(.+)$/);
      const infoValueMatch = tagName.match(/^InfoValue:(.+)$/);
      if (infoLabelMatch) {
        const key = infoLabelMatch[1];

        // First, check if the key exists in barcodeTags
        if (barcodeTags[key]) return barcodeTags[key];

        if (barcodePrintTags?.find((tag) => tag.value === key)) {
          return barcodePrintTags.find((tag) => tag.value === key).label;
        }

        // If no value found, return the original tag
        return `<${tagName}>`;
      }
      if (infoValueMatch) {
        const key = infoValueMatch[1].split(',')[0];
        const length = infoValueMatch[1].split(',')[1]
          ? infoValueMatch[1].split(',')[1]
          : primaryCalculationType === 'lal'
            ? 1
            : 3;
        // First, check if the key exists in barcodeTags
        if (barcodeTags[key]) return barcodeTags[key];
        if (extraDetails?.[index]?.[key] !== undefined) {
          if (
            barcodePrintTags.find((tag) => tag.value === key).type === 'info'
          ) {
            if (key.toLowerCase().includes('amount')) {
              return Number.parseFloat(extraDetails[index][key]).toFixed(
                length || 3,
              );
            } else {
              return Number.parseFloat(extraDetails[index][key]).toFixed(
                length,
              );
            }
          } else if (
            barcodePrintTags.find((tag) => tag.value === key).type === 'text'
          ) {
            return extraDetails[index][key].slice(0, length);
          } else {
            return extraDetails[index][key];
          }
        } else if (
          extraDetails?.[index]?.diamondData &&
          extraDetails?.[index]?.diamondData?.length > 0 &&
          key.includes('Diamond')
        ) {
          const keys = key.split('-');
          return (
            extraDetails?.[index]?.diamondData[Number(parseInt(keys[2])) - 1]?.[
              keys[1]
            ] || 0
          );
        } else if (
          extraDetails?.[index]?.stoneData &&
          extraDetails?.[index]?.stoneData?.length > 0 &&
          key.includes('Stone')
        ) {
          const keys = key.split('-');
          return (
            extraDetails?.[index]?.stoneData[Number(parseInt(keys[2])) - 1]?.[
              keys[1]
            ] || 0
          );
        } else if (key === 'netWeightSc') {
          if (extraDetails?.[index]['netWeight'].includes('lal')) {
            return LalToGramConversion(
              Number.parseFloat(extraDetails?.[index]['netWeight']),
            ).toFixed(length);
          } else {
            return gramToLalConversion(
              Number.parseFloat(extraDetails?.[index]['netWeight']),
            ).toFixed(length);
          }
        } else if (key === 'wtInTola') {
          const netWeightStr = extraDetails[index]['netWeight'] || '';
          let value = 0; // default

          const parts = netWeightStr.trim().split(' ');
          const num = parseFloat(parts[0]);

          if (!isNaN(num)) {
            if (netWeightStr.includes('lal')) {
              value = num / 100;
            } else if (netWeightStr.includes('gm')) {
              value = gramToLalConversion(num) / 100;
            }
          }

          return value.toFixed(length);
        }

        // If no value found, return the original tag
        return 0;
      }
      // Existing replacement logic for other tags
      switch (tagName) {
        case 'Barcode':
          return extraDetails?.[index]?.itemCode;
        case 'itemCode':
          return extraDetails?.[index]?.itemCode;
        case 'itemGroup':
          // return extraDetails?.[index]?.itemCode;
          return extraDetails?.[index]?.groupName;
        case 'description':
          return extraDetails?.[index]?.description;
        case 'karigarName':
          return extraDetails?.[index]?.karigarName;
        case 'itemName':
          return itemName;
        case 'Purity':
          return extraDetails?.[index]?.purityInCarat;
        case 'totalSalesStoneAmount':
          return summaryData
            ? summaryData?.totalSalesStoneAmount
            : extraDetails?.[index]?.totalSalesStoneAmount;
        case 'totalSalesDiamondAmount':
          return summaryData
            ? summaryData?.totalSalesDiamondAmount
            : extraDetails?.[index]?.totalSalesDiamondAmount;
        // case 'PurityInPercent':
        //   return extraDetails?.[index]?.purity?.toFixed(length || 3);
        case 'printQty':
          return Number(form.getFieldValue('printQuantity')) || '';
        case 'generalRemarks':
          return form.getFieldValue('generalRemarks');
        case 'size':
          return extraDetails?.[index]?.size || '';
        default:
          // Check barcodeTags for any custom tags
          if (extraDetails?.[index]?.[tagName])
            return extraDetails?.[index]?.[tagName];
          return `<${tagName}>`;
      }
    },
  };

  // Regular expression to find all template tags
  const templateTagRegex = /<([^>]+)>/g;

  prn.replace(templateTagRegex, (match, tagName) => {
    // Use the replacement strategy for each tag
    prnKeyValueMap[tagName] = templateReplacements.default(tagName);
  });
  return prnKeyValueMap;
};
